import { Poll } from 'features/polls/types';

export const resetPoll = (poll: Poll) => {
  poll.votersCount = 0;
  if (poll.choices) {
    for (const choice of poll.choices) {
      choice.votersCount = 0;
    }
  }
  poll.shared = false;
  poll.active = false;
  poll.ended = false;
  poll.editable = false;
  delete poll.voted;
};
